import {
  IStreamVideo,
  IStreamVideoResumableUpload,
  StreamVideoState,
} from '@/shared/types/common';

const VIDEO_STATUSES = new Set<IStreamVideo['status']>(['pending', 'ready', 'error']);
const STREAM_STATES = new Set<StreamVideoState>([
  'pendingupload',
  'downloading',
  'queued',
  'inprogress',
  'missing',
]);

const mapResumableUpload = (raw: unknown): IStreamVideoResumableUpload | null => {
  if (!raw || typeof raw !== 'object') {
    return null;
  }
  const { url, fileSize, fileLastModified } = raw as Record<string, unknown>;
  if (typeof url !== 'string' || !url) {
    return null;
  }
  return {
    url,
    fileSize: typeof fileSize === 'number' ? fileSize : null,
    fileLastModified: typeof fileLastModified === 'number' ? fileLastModified : null,
  };
};

export const mapLessonVideo = (video: unknown): IStreamVideo | null => {
  if (!video || typeof video !== 'object') {
    return null;
  }

  const raw = video as Record<string, unknown>;
  const embedUrl =
    (typeof raw.embedUrl === 'string' && raw.embedUrl) ||
    (typeof raw.embed_url === 'string' && raw.embed_url) ||
    undefined;
  const url =
    (typeof raw.url === 'string' && raw.url) ||
    (typeof raw.playbackUrl === 'string' && raw.playbackUrl) ||
    (typeof raw.playback_url === 'string' && raw.playback_url) ||
    (typeof raw.hls === 'string' && raw.hls) ||
    '';
  const statusRaw = raw.status;
  const status = VIDEO_STATUSES.has(statusRaw as IStreamVideo['status'])
    ? (statusRaw as IStreamVideo['status'])
    : embedUrl || url
      ? 'ready'
      : 'pending';

  if (!embedUrl && !url && status !== 'pending' && status !== 'error') {
    return null;
  }

  return {
    id: typeof raw.id === 'number' ? raw.id : 0,
    name: typeof raw.name === 'string' ? raw.name : 'Video',
    url,
    size: typeof raw.size === 'number' ? raw.size : 0,
    mime: typeof raw.mime === 'string' ? raw.mime : 'video/mp4',
    provider: 'cloudflare-stream',
    status,
    embedUrl,
    thumbnailUrl:
      (typeof raw.thumbnailUrl === 'string' && raw.thumbnailUrl) ||
      (typeof raw.thumbnail_url === 'string' && raw.thumbnail_url) ||
      undefined,
    duration: typeof raw.duration === 'number' ? raw.duration : undefined,
    errorReason: typeof raw.errorReason === 'string' ? raw.errorReason : null,
    urlExpiresAt: typeof raw.urlExpiresAt === 'string' ? raw.urlExpiresAt : null,
    streamState: STREAM_STATES.has(raw.streamState as StreamVideoState)
      ? (raw.streamState as StreamVideoState)
      : null,
    pctComplete: typeof raw.pctComplete === 'number' ? raw.pctComplete : null,
    uploadExpiresAt: typeof raw.uploadExpiresAt === 'string' ? raw.uploadExpiresAt : null,
    resumableUpload: mapResumableUpload(raw.resumableUpload),
  };
};
